// Result phase — WIN ONLY. docs/fe-state-machine.md#result.

import type { Phase } from "../state/types";
import { reportPlay } from "../api/client";
import { mountFrame, clearChildren } from "../ui/overlay";
import { getSignature } from "../crypto";

function closeGameToParent(winnerId: number | null): void {
  try {
    window.parent?.postMessage({ type: "close_game", winner_id: winnerId }, "*");
  } catch (e) {
    console.warn("[Result] close_game postMessage failed", e);
  }
}

const FLOW = "/textures/flow";
const WIN_FPS = 9;

const LOGO_TOP = "2%";
const LOGO_WIDTH = "85%";
const PANEL_TOP = "13%";
const PANEL_WIDTH = "90%";
const CHAR_HEIGHT = "33%";
const CHAR_BOTTOM = "23%";

let cleanup: (() => void) | null = null;
let frameTimer: ReturnType<typeof setInterval> | null = null;

export const Result: Phase = {
  enter(ctx) {
    const root = document.getElementById("app")!;
    clearChildren(root);

    const bg = document.createElement("div");
    bg.className = "app-bg";
    bg.style.backgroundImage = "url(/textures/bg_indexA.png)";
    bg.style.backgroundColor = "#f7c7d8";

    const frame = document.createElement("div");
    frame.className = "app-frame";
    frame.style.cssText = "position:relative;overflow:hidden;";

    const winFrames = [0, 1, 2, 3, 4].map((i) => `${FLOW}/resultWin_${i}.png`);

    frame.innerHTML = `
      <img src="/textures/bg_index.png" alt="" style="
        position:absolute;bottom:0;left:50%;transform:translateX(-50%);
        width:100%;object-fit:contain;pointer-events:none;"/>
      <div id="resultChar" style="
        position:absolute;bottom:${CHAR_BOTTOM};left:50%;transform:translateX(-50%);
        height:${CHAR_HEIGHT};aspect-ratio:704/924;pointer-events:none;">
        ${winFrames
          .map(
            (u, i) =>
              `<img src="${u}" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;opacity:${i === 0 ? 1 : 0};"/>`,
          )
          .join("")}
      </div>
      <img src="${FLOW}/resultPanel.png" alt="" style="
        position:absolute;top:${PANEL_TOP};left:50%;transform:translateX(-50%);
        width:${PANEL_WIDTH};object-fit:contain;pointer-events:none;"/>
      <img src="${FLOW}/LogoHeader.png" alt="" style="
        position:absolute;top:${LOGO_TOP};left:50%;transform:translateX(-50%);
        width:${LOGO_WIDTH};object-fit:contain;pointer-events:none;"/>
      <button id="leaderboard" style="
        position:absolute;bottom:4%;left:50%;transform:translateX(-50%);
        width:70%;background:none;border:0;padding:0;cursor:pointer;
        background-image:url(${FLOW}/ButtonLeaderBoard.png);background-size:contain;
        background-repeat:no-repeat;background-position:center;aspect-ratio:1128/236;"
        aria-label="Xem bảng xếp hạng"></button>
      <button id="replay" style="
        position:absolute;top:2%;right:3%;font-size:11px;padding:3px 8px;border-radius:6px;
        border:0;background:#0006;color:#fff;cursor:pointer;">Chơi lại (test)</button>
    `;

    // Report completed game với sessionId
    if (ctx.winnerId != null) {
      getSignature(ctx.sessionId ?? "", ctx.winnerId).then((sig) => {
        reportPlay({
          winnerId: ctx.winnerId!,
          userId: ctx.uid,
          signature: ctx.sessionId ? sig : null,
        })
          .then((r) => console.info("[Result] play reported", r))
          .catch((e) => console.warn("[Result] play report failed", e));
      });
    } else {
      console.info("[Result] no winner_id (standalone build) — skipping play report");
    }

    root.appendChild(bg);
    const frameCleanup = mountFrame(root, frame);
    cleanup = () => {
      if (frameTimer != null) {
        clearInterval(frameTimer);
        frameTimer = null;
      }
      if (bg.parentElement === root) root.removeChild(bg);
      frameCleanup();
    };

    const charImgs = Array.from(
      frame.querySelectorAll<HTMLImageElement>("#resultChar img"),
    );
    void Promise.all(charImgs.map((im) => im.decode().catch(() => undefined))).then(() => {
      if (cleanup == null) return;
      let fi = 0;
      frameTimer = setInterval(() => {
        charImgs[fi].style.opacity = "0";
        fi = (fi + 1) % charImgs.length;
        charImgs[fi].style.opacity = "1";
      }, Math.round(1000 / WIN_FPS));
    });

    frame.querySelector<HTMLButtonElement>("#leaderboard")!.addEventListener("click", () => {
      closeGameToParent(ctx.winnerId);
    });

    frame.querySelector<HTMLButtonElement>("#replay")!.addEventListener("click", () => {
      const params = new URLSearchParams(location.search);
      params.set("uid", ctx.uid);
      location.search = params.toString();
    });
  },
  exit() {
    cleanup?.();
    cleanup = null;
  },
};
